import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";

import RootView from "../web/root-view";

@Options({
    template: false,
    ui: {
        item: "[data-js-ui=item]",
        itemToggle: "[data-js-ui=item-toggle]",
        itemContent: "[data-js-ui=item-content]",
        viewAllBtn: "[data-js-ui=view-all]",
        viewDetailBtn: "[data-js-ui=view-detail]",
        hiddenItems: ".hidden-item"
    }
})
export default class AccordionView extends Marionette.View<Backbone.Model>{

    _activeClass         = "is--active";
    _showAllClass        = "is-showing-all";
    _hasHiddenItemsClass = "has-hidden-items";

    onRender() {
        this.checkHiddenItems();
        this.expandAnchorItem();
    }

    @on("click @ui.viewAllBtn")
    onViewAllClicked(e) {
        this.$el.addClass(this._showAllClass);
    }

    @on("click @ui.viewDetailBtn")
    onViewDetailClicked(e) {
        e.stopPropagation();
    }

    @on("click @ui.itemToggle")
    onItemToggleClick(e) {
        const $target = $(e.currentTarget);
        const isActive = $target.hasClass(this._activeClass);
        e.preventDefault();

        if (isActive) {
            this.closeItem($target);
        } else {
            this.openItem($target);
        }
    }

    checkHiddenItems() {
        if (this.ui.hiddenItems.length) {
            this.$el.addClass(this._hasHiddenItemsClass);
        }
        const $this = this;
        this.$el.find('.' + this._activeClass).each(function(i, obj){
            $this.openItem($(obj));
        })
    }

    expandAnchorItem() {
        const madeTarget = window.madeTarget;
        if (madeTarget) {
            const $anchorToggle = this.$el.find(`#${madeTarget} > a:first`);

            if ($anchorToggle.length) {
                this.openItem($anchorToggle);
            }
        }
    }

    closeItem($el) {
        $el.next(this.ui.itemContent).removeClass("open-height");
        $el.removeClass(this._activeClass);
        $el.attr("aria-expanded", "false");
        _.delay(_.bind(this.triggerResize, this), 50);
    }

    openItem($el:any) {
        $el.addClass(this._activeClass);
        $el.attr("aria-expanded", "true");
        $el.next(this.ui.itemContent).addClass("open-height");
        _.delay(_.bind(this.triggerResize, this), 50);
    }
    triggerResize(){
        $(window).trigger('resize')
    }
}



// WEBPACK FOOTER //
// ./@modules/views/accordion-view.ts